// Utilisé pour la page recap, mais TODO:
// Crée une erreur: missing required prop "option"
import { Component } from 'vue-property-decorator';
import InputBase from '@/components/inputs/base/InputBase';

@Component
export default class InputEmail extends InputBase<string> {
  protected mounted() {
    this.inputType = 'email';
  }
}
